import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { siteInfo } from "@/mocks/site";
import { topics } from "@/mocks/topics";
import { formatHeat } from "@/components/feature/TopicCard";

export default function Hero() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const topTopic = topics[0];

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/topics?q=${encodeURIComponent(q)}` : "/topics");
  };

  return (
    <section className="border-b border-background-200 bg-gradient-to-b from-primary-50 via-background-100 to-background-50">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-[1.15fr_1fr] lg:gap-14">
        <div className="fade-up">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3.5 py-1.5 text-xs font-medium text-accent-700">
            <i className="ri-fire-line"></i>
            今日热议 · 瓜友正在讨论
          </span>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight tracking-tight text-foreground-950 md:text-5xl">
            黑料专区
            <span className="mt-2 block text-primary-600 md:text-4xl">
              热门吃瓜话题与瓜友热议交流
            </span>
          </h1>

          <p className="mt-5 max-w-xl text-base leading-8 text-foreground-600">
            把每天刷屏的娱乐话题整理成一张张话题卡片，看背景、看观点、看后续。
            想参与吃瓜评论或围观更多吃瓜话题，来黑料专区，与瓜友一起讨论、交流、分享你的看法。
          </p>

          <form onSubmit={handleSearch} className="mt-7 flex max-w-xl flex-col gap-3 sm:flex-row">
            <div className="flex flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-4 py-3 focus-within:border-primary-400">
              <i className="ri-search-line text-base text-foreground-500"></i>
              <input
                type="text"
                name="keyword"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索你想围观的话题，如 剪辑、结局、抢票"
                className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
              />
            </div>
            <button
              type="submit"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-compass-3-line"></i>
              去找话题
            </button>
          </form>

          <dl className="mt-9 grid grid-cols-2 gap-5 sm:grid-cols-4">
            {siteInfo.stats.map((stat) => (
              <div key={stat.label}>
                <dt className="text-xs text-foreground-600">{stat.label}</dt>
                <dd className="mt-1 font-heading text-2xl font-bold text-foreground-950">
                  {stat.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative fade-up">
          <div className="h-[340px] w-full overflow-hidden rounded-lg bg-background-200 md:h-[460px] lg:h-[520px]">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20illustration%20of%20glowing%20amber%20spotlight%20beams%20and%20floating%20speech%20bubbles%20over%20a%20warm%20cream%20background%20with%20soft%20grain%20texture%20layered%20geometric%20shapes%20lively%20discussion%20atmosphere%20no%20text%20no%20people%20minimal%20modern%20magazine%20poster%20style%20harmonious%20warm%20color%20palette&width=900&height=1000&seq=gossip-hero-01&orientation=portrait"
              alt="吃瓜话题讨论的抽象插画，暖色光束与对话气泡"
              title="黑料专区 吃瓜讨论社区 热门话题"
              className="h-full w-full object-top"
            />
          </div>

          <Link
            to={`/topic/${topTopic.id}`}
            className="absolute -bottom-5 left-4 right-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:left-8 md:right-8"
          >
            <div className="flex items-center gap-2 text-xs font-medium text-accent-600">
              <i className="ri-fire-fill"></i>
              今日最热
              <span className="ml-auto text-foreground-500">
                {formatHeat(topTopic.heat)} 热度
              </span>
            </div>
            <p className="mt-2 line-clamp-1 font-heading text-base font-semibold text-foreground-950">
              {topTopic.title}
            </p>
          </Link>
        </div>
      </div>
    </section>
  );
}